import React, { useEffect, useRef, useState } from 'react'
import Header from 'layout/header';
import Footer from 'layout/footer';
import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
// import 'swiper/css/effect-fade';
import AOS from 'aos';
import 'aos/dist/aos.css';

// import gsap from 'gsap';

import modelInLogo from 'assets/images/logo_modelin.png';
import linkInLogo from 'assets/images/logo_linkin.png';
import openInLogo from 'assets/images/logo_openin.png';
import collectInLogo from 'assets/images/logo_collectin.png';

import modelBanner from 'assets/images/banner01.png';
import linkBanner from 'assets/images/banner02.png';
import openBanner from 'assets/images/banner03.png';
import collectBanner from 'assets/images/banner04.png';

import cj from 'assets/images/logo_cj.png';
import theFin from 'assets/images/logo_fin.png';
import kinfa from 'assets/images/logo_kinfa.png';
import kofia from 'assets/images/logo_kofia.png';
import mg from 'assets/images/logo_mg.png';
import sh from 'assets/images/logo_sh.png';
import woori from 'assets/images/logo_woori.png';
import wooriCard from 'assets/images/logo_wooricard.png';
import zero from 'assets/images/logo_zero.png';
import wooribnk from 'assets/images/logo_wooribnk.png';
import bnk from 'assets/images/logo_bnk.png';
import ibk from 'assets/images/logo_ibk.png';
import moe from 'assets/images/logo_moe.png';

import coocon from 'assets/images/logo_coocon.png';
import danal from 'assets/images/logo_danal.png';
import hyundai from 'assets/images/logo_hyundai.png';
import ibkins from 'assets/images/logo_ibkins.png';
import kbbank from 'assets/images/logo_kbbank.png';
import kbinsure from 'assets/images/logo_kbinsure.png';
import kbsec from 'assets/images/logo_kbsec.png';
import koreabank from 'assets/images/logo_koreabank.png';
import koreacap from 'assets/images/logo_koreacap.png';
import shinhan from 'assets/images/logo_shinhan.png';

import map from 'assets/images/img_map.png';


const Main = () => {

    const navigate = useNavigate();
    const swiperRef = useRef(null);
    const logoSwiperRef = useRef(null);
    const autoplayButtonRef = useRef(null);
    const [isAutoplay, setIsAutoplay] = useState(true);

    const slideBanner = [
        {
            logo: modelInLogo,
            banner: modelBanner,
            title: '통합 인터페이스 관리 시스템',
            txt: '다양한 연계 시스템의 인터페이스 정보를 통합 관리하세요. 인터페이스 정보 및 IO 정보를 빠르게 공유할 수 있습니다.',
          },
          {
            logo: linkInLogo,
            banner: linkBanner,
            title: '통합 업무 연계 시스템',
            txt: '다양한 프로토콜, 메시지 타입, 인터페이스 등 연계 정보를 업무 시스템에 맞춰 개발 가능하게 API를 지원합니다.',
          },
          {
            logo: openInLogo,
            banner: openBanner,
            title: '오픈 API 포탈 · 관리 시스템',
            txt: '다양한 API 개발 표준화를 하여 Doc, Test Bed 등을 제공하고 관리합니다.',
          },
          {
            logo: collectInLogo,
            banner: collectBanner,
            title: '빅데이터 수집 · 적재 시스템',
            txt: '대용량 데이터를 수집하며 필요한 형태로 가공/적재합니다.',
          },
    ]

    // 페이지네이션 애니메이션 적용 함수
    const handlePager = (activeIndex) => {
        const progressBars = document.querySelectorAll('.progress');
        
        progressBars.forEach((bar, index) => {

            // 모든 progress 초기화
            bar.style.transform = 'scaleX(0)';
            bar.style.transition = 'transform 0s'; // 초기 상태에서는 애니메이션을 하지 않음

            // 활성화된 슬라이드에만 애니메이션 적용
            if (index === activeIndex && isAutoplay) {
                bar.style.transition = 'transform 4s linear'; // 애니메이션 속도 설정
                bar.style.transform = 'scaleX(1)'; // 활성화된 슬라이드에 애니메이션 적용
            } 
        });
    };

    // 재생, 정지버튼
    const toggleAutoplay = () => {
        if (swiperRef.current) {
            if (isAutoplay) {
                swiperRef.current.autoplay.stop();
            } else {
                swiperRef.current.autoplay.start();
                handlePager(swiperRef.current.activeIndex);
            }
            setIsAutoplay(!isAutoplay);
        }
    };

    // project
    // 이미지 리스트
    const projectLogo = [
        cj, theFin, kinfa, kofia, mg, sh, woori, wooriCard, wooribnk, zero, bnk, ibk, ibkins, moe
        , coocon, danal, hyundai, kbbank, kbinsure, kbsec, koreabank, koreacap, shinhan
    ];

     // AOS 초기화 및 리프레시
     useEffect(() => {
        AOS.init();
    }, []);

    return (    
        <div id='wrap'>
            <Header/>
            <section className='section'>
                <div className="content banner">
                    <Swiper
                        ref={swiperRef}
                        className="main-swiper"
                        modules={[Pagination, Autoplay ]}
                        loop={true}
                        speed={800}
                        slidesPerView={1}
                        autoplay={{
                            delay: 4000,
                            disableOnInteraction: false, // 사용자 상호작용 후에도 자동 전환 유지
                        }}
                        pagination={{
                            el: '.swiper-control .pagination',
                            clickable: true,
                            renderBullet: (className) => `
                                <span class="${className} bar">
                                    <span class="progress"></span>
                                </span>
                            `,
                        }}
                        // Swiper 초기화 시 첫 번째 슬라이드에 애니메이션 실행
                        onInit={(swiper) => {
                            // setTimeout을 사용해 첫 번째 슬라이드가 렌더링 된 후에 애니메이션 실행
                            setTimeout(() => {
                                const activeIndex = swiper.activeIndex;  // 현재 활성화된 슬라이드 인덱스
                                handlePager(activeIndex);  // 첫 번째 슬라이드 애니메이션 실행
                            }, 0);
                        }}
                        onSlideChange={(swiper) => {
                            const activeIndex = swiper.realIndex;
                            handlePager(activeIndex);
                        }}
                        onSwiper={(swiper) => {
                            swiperRef.current = swiper; // Swiper 인스턴스 할당
                        }}
                    >

                        {slideBanner.map((banner, idx) => (
                            <SwiperSlide key={idx}>
                                <div className="banner-txt">
                                    <div className="logo-area">
                                        <img src={banner.logo} alt={banner.title}/>
                                    </div>
                                    <span className="title">{banner.title}</span>
                                    <p className="txt">{banner.txt}</p>
                                </div>
                                <div className="banner-img">
                                    <img src={banner.banner} alt={banner.title}/>
                                </div>
                            </SwiperSlide>
                        ))}

                        <div className="swiper-control">
                            <div className="pagination"></div>
                            <button
                                ref={autoplayButtonRef}
                                className={`swiper-autoplay ${isAutoplay ? 'stop' : 'play'}`}
                                onClick={toggleAutoplay}
                            />
                        </div>
                    </Swiper>    
                </div>

                <div className="content about">
                    <div className="container">
                        <p className="section-title" data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-delay="500">ABOUT</p>

                        <div className="flex-box">
                            <div className="card img01" data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-delay="600" onClick={() => navigate("/solutions/solution", { replace: false })}>
                                <span data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-delay="650">연계 솔루션 제공</span><br></br>
                                <span data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-delay="650">(ESB|LinkIN, EIMS|ModelIN)</span>
                            </div>
                            <div className="card img02" data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-delay="800" onClick={() => navigate("/introduce/business", { replace: false })}>
                                <span data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-delay="850">프로그램 사업 구축</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="content project">
                    <Swiper
                        ref={logoSwiperRef}
                        className='logo-swiper'
                        modules={[Autoplay]}
                        spaceBetween={80}
                        speed={2500}
                        autoplay={{
                            delay: 0,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: false,
                        }}
                        loop={true}
                        slidesPerView="auto"
                        allowTouchMove={false}
                        observer={true}
                        observeParents={true}
                    >
                        {/* 슬라이드 최소 개수 보장 - v11은 slidesPerView 대비 충분한 슬라이드 필요 */}
                        {[...projectLogo, ...projectLogo].map((src, idx) => (
                            <SwiperSlide key={idx}>
                                <div className="img-box">
                                    <img src={src} alt={`project clone ${idx + 1}`} />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>

                <div className="content contact">
                    <div className="container">
                        <p className="section-title" data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-delay="500">CONTACT US</p>

                        <div className="card map" data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-delay="550">
                            <img src={map} alt="map"/>
                        </div>

                        <div className="flex-box">
                            <div className="card address" data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-delay="600">
                                <span className='tit'>주소</span>
                                <div className="flex-box info">
                                    <span className='txt'>서울 영등포구 영신로 166 반도아이비밸리 1005호</span>
                                    <a href="https://map.naver.com/p/entry/place/36932003?c=15.00,0,0,0,dh" className="btn map" target="_blank"><span>지도보기</span></a>
                                </div>
                            </div>
                            <div className="flex-box type-col">
                                <a href="tel:+025691171" className="card call" data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-delay="650">
                                    <i className="icon call"></i>
                                    <span>02-569-1171</span>
                                </a>
                              
                                <a href="mailto:info@inissoft.com" className="card email" data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-delay="700">
                                    <i className="icon email"></i>
                                    <span>info@inissoft.com</span>
                                </a>
                            </div>
                            
                        </div>
                    </div> 
                </div>            
            </section>
        
            <Footer/>
           
        </div>
    )
}


export default Main